import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StyleService {

  constructor(@Inject(DOCUMENT) private document: Document) { }

  /** Finds a style element by its ID in the document head. */
  find(id: string): HTMLStyleElement {
    return this.document.getElementById(id) as HTMLStyleElement;
  }

  /** Creates and injects a style element into the document head. */
  create(id: string = null, cssText: string = ''): HTMLStyleElement {
    let styleElement = this.find(id);
    if (!styleElement) {
      styleElement = this.document.createElement('style');
      if (id)
        styleElement.id = id;
      const head = this.document.getElementsByTagName('head')[0];
      head.appendChild(styleElement);
    }
    styleElement.textContent = cssText;
    return styleElement;
  }

  /** Removes the specified style element from the document head. */
  remove(styleElement: HTMLStyleElement | string): void {
    if (typeof styleElement === 'string') {
      styleElement = this.find(styleElement);
    }
    if (styleElement?.parentNode) {
      styleElement.parentNode.removeChild(styleElement);
    }
  }

}
